import { Loader2 } from "lucide-react";
import { MarkdownRenderer } from "@/modern/components/ui/markdown-renderer";
import { useSMMGeneratorContext } from "../context/SMMGeneratorContext";
import { MANIFEST_GUIDE_TARGETS, guideTargetProps } from "@/react/guides";
import { ManifestDocumentHeader } from "./ManifestDocumentHeader";

const ManifestSkeleton = () => (
  <div className="px-4 py-3 space-y-3">
    <div className="flex items-center gap-2">
      <Loader2 className="h-3.5 w-3.5 animate-spin text-muted-foreground" />
      <span className="text-xs text-muted-foreground">Compiling manifest from Context…</span>
    </div>
    <div className="space-y-2 animate-pulse">
      <div className="h-3 bg-muted/40 rounded w-3/4" />
      <div className="h-3 bg-muted/40 rounded w-full" />
      <div className="h-3 bg-muted/40 rounded w-5/6" />
    </div>
  </div>
);

interface ManifestEditorProps {
  onGoToContext?: () => void;
  onShowGuide?: () => void;
  isFocused?: boolean;
  onToggleFocus?: () => void;
}

export const ManifestEditor = ({
  onGoToContext,
  onShowGuide,
  isFocused = false,
  onToggleFocus,
}: ManifestEditorProps) => {
  const { manifestContent, isGenerating } = useSMMGeneratorContext();

  return (
    <div className="flex flex-1 min-h-0 flex-col overflow-hidden" {...guideTargetProps(MANIFEST_GUIDE_TARGETS.manifestBody)}>
      <ManifestDocumentHeader
        isGenerating={isGenerating}
        onGoToContext={onGoToContext}
        onShowGuide={onShowGuide}
        isFocused={isFocused}
        onToggleFocus={onToggleFocus}
      />

      <div className="flex-1 min-h-0 overflow-y-auto">
        {isGenerating ? (
          <ManifestSkeleton />
        ) : (
          <div className={isFocused ? "px-6 py-4 max-w-4xl mx-auto w-full" : "px-4 py-3"}>
            <MarkdownRenderer content={manifestContent} />
          </div>
        )}
      </div>
    </div>
  );
};
